import { getStores, hasSDK } from '@littlebird/sdk';

import { archivedChatSearchId, mcpClientSearchId } from './settings-search-dom';

import type { SettingsSearchProvider } from './settings-search.config';

/** Search providers read the same SDK store as their pane. */

/** Authorized MCP clients shown in the MCP Clients pane (SDK-synced store) */
export const mcpClientsSearchProvider: SettingsSearchProvider = {
  sectionId: 'McpClients',
  getEntries: async (ctx) => {
    if (!ctx.hasMcpServerAccess || !hasSDK()) return [];
    return [...getStores().mcpClientGrants.data.values()]
      .filter((grant) => !grant.deletedAt)
      .map((grant) => ({
        id: mcpClientSearchId(grant.id),
        sectionId: 'McpClients',
        label: grant.clientName,
        keywords: ['mcp client'],
      }));
  },
};

/** Newest-first cap keeping unbounded archives out of the search set */
export const ARCHIVED_CHATS_SEARCH_CAP = 50;

/** Archived chat titles from the SDK thread store the pane renders from */
export const archivedChatsSearchProvider: SettingsSearchProvider = {
  sectionId: 'ArchivedChats',
  getEntries: async () => {
    if (!hasSDK()) return [];
    // archivedChats is ordered by last update desc, so the slice keeps the
    // most recently touched chats
    return getStores()
      .threads.archivedChats.slice(0, ARCHIVED_CHATS_SEARCH_CAP)
      .map((thread) => ({
        id: archivedChatSearchId(thread.id),
        sectionId: 'ArchivedChats',
        label: thread.title || 'Untitled',
        keywords: ['archive'],
      }));
  },
};
